import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'extractionP50',
    'extractionP95',
    'extractionP99',
    'extractionAvg',
    'analysisP50',
    'analysisP95',
    'analysisP99',
    'analysisAvg',
    'errorRate',
    'stuckCount'
  ]

  static values = {
    url: String
  }

  connect() {
    this.loadData()
  }

  async loadData() {
    try {
      const response = await fetch(this.urlValue, {
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin'
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      this.renderStats(data)
    } catch (error) {
      console.error('Failed to load performance data:', error)
    }
  }

  renderStats(data) {
    // Extraction time
    if (data.extraction_time) {
      this.setTarget('extractionP50', this.formatMs(data.extraction_time.p50))
      this.setTarget('extractionP95', this.formatMs(data.extraction_time.p95))
      this.setTarget('extractionP99', this.formatMs(data.extraction_time.p99))
      this.setTarget('extractionAvg', this.formatMs(data.extraction_time.avg))
    }

    // Analysis time
    if (data.analysis_time) {
      this.setTarget('analysisP50', this.formatMs(data.analysis_time.p50))
      this.setTarget('analysisP95', this.formatMs(data.analysis_time.p95))
      this.setTarget('analysisP99', this.formatMs(data.analysis_time.p99))
      this.setTarget('analysisAvg', this.formatMs(data.analysis_time.avg))
    }

    // Error rates
    if (data.error_rates) {
      this.setTarget('errorRate', `${data.error_rates.extraction_failed}%`)
      this.setTarget('stuckCount', data.error_rates.processing_stuck)
    }
  }

  setTarget(name, value) {
    const targetName = `${name}Target`
    const hasTargetName = `has${name.charAt(0).toUpperCase() + name.slice(1)}Target`

    if (this[hasTargetName]) {
      this[targetName].textContent = value
    }
  }

  formatMs(ms) {
    if (ms === null || ms === undefined) return 'N/A'
    if (ms < 1000) return `${ms}ms`
    return `${(ms / 1000).toFixed(1)}s`
  }
}
